"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.getAncestors=function(e){var t=e.closest(".stackable");return t?t.getAttribute("data-ancestors"):""};
